// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3eRg7","footer":"ChangeClinic_footer__3FMwq"};